import $ from 'jquery';

export function bindTopNavHamburger(topNavBurger){
  topNavBurger.on('click', onBurgerClick);

  function onBurgerClick(e){
    e.preventDefault();
    const link = $(this);
    link.closest('.navbar').find('.top-nav-list-content').collapse('toggle');
  }
}


// WEBPACK FOOTER //
// ./src/utilities/jumboNav/index.js